import { useCallback, useEffect, useState } from 'react';

interface UseToggleOptions {
  withStorage?: boolean;
  storageKey?: string;
}

export const useToggle = (
  initialValue = false,
  options: UseToggleOptions = {}
) => {
  const { withStorage = false, storageKey = '' } = options;

  const getInitialValue = (): boolean => {
    if (withStorage) {
      const stored = localStorage.getItem(storageKey);
      if (stored !== null) {
        return stored === 'true';
      }
      return false;
    }
    return initialValue;
  };

  const [isOpen, setIsOpen] = useState(getInitialValue);

  useEffect(() => {
    if (withStorage) {
      localStorage.setItem(storageKey, String(isOpen));
    }
  }, [isOpen, withStorage, storageKey]);

  const onOpen = useCallback(() => {
    setIsOpen(true);
  }, []);

  const onClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  const toggle = useCallback(() => {
    setIsOpen((open) => !open);
  }, []);

  return {
    isOpen,
    onOpen,
    onClose,
    toggle,
    setIsOpen,
  };
};

export default useToggle;
